import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_outbound_order_tasks_with_manufacturing_finished_productService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_id?: number, project_id?: number, warehouse_id?: number, lot?: number, location?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, ExpectedTargetLicensePlateId?: number, ExpectedTargetLocationId?: number, LotId?: number, MaterialId?: number, OperationCodeId?: number, StatusId?: number, WarehouseId?: number, Order?: { LookupCode?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_outbound_order_tasks_with_manufacturing_finished_product/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { material_id?: number, project_id?: number, warehouse_id?: number, lot?: number, location?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, ExpectedTargetLicensePlateId?: number, ExpectedTargetLocationId?: number, LotId?: number, MaterialId?: number, OperationCodeId?: number, StatusId?: number, WarehouseId?: number, Order?: { LookupCode?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_outbound_order_tasks_with_manufacturing_finished_product/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_id?: number, project_id?: number, warehouse_id?: number, lot?: number, location?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, ExpectedTargetLicensePlateId?: number, ExpectedTargetLocationId?: number, LotId?: number, MaterialId?: number, OperationCodeId?: number, StatusId?: number, WarehouseId?: number, Order?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_outbound_order_tasks_with_manufacturing_finished_product/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_id?: number, project_id?: number, warehouse_id?: number, lot?: number, location?: number    }) {
      return false;
    }
}
